import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MinusIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M16,9 C16,9 10.6666667,9 0,9 L0,7 L16,7 C16,8.33333333 16,9 16,9 Z"
        data-testid="icon-minus"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
